import { MuiTheme } from "theme";
import { makeStyles } from "@material-ui/core/styles";
import Breakpoints from "common/breakpoints";

export default makeStyles((theme: MuiTheme) => ({
  dialogActions: {
    display: "flex",
    justifyContent: "flex-end",
    padding: "0 8px 12px"
  },
  actionButton: {
    height: 32,
    padding: "0 10px",
    marginLeft: 10,
    fontSize: 16,
    color: theme.palette.primary.dark,
    borderRadius: 2,
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
    "&:first-child": {
      marginLeft: 0
    },
    [theme.breakpoints.down(Breakpoints.SM_600)]: {
      padding: "0 4px"
    }
  },
  successButton: {
    color: theme.palette.secondary.dark
  },
  cancelButton: {
    color: "#f73d54"
  }
}));
